'use strict';

var expressStencils = require('../components/expressStencils');
var paymentUtils = require('../components/paymentUtils');
var scrollAnimate = require('base/components/scrollAnimate');

/**
 * Shows the PayPal loading backdrop to prevent user interaction during PayPal modal loading.
 */
function showPayPalBackdrop() {
    if (!$('.paypal-loading-backdrop').length) {
        $('body').append('<div class="paypal-loading-backdrop"></div>');
    }
    $('.paypal-loading-backdrop').addClass('active');
    $('body').addClass('paypal-loading-active');
}

/**
 * Removes the PayPal loading backdrop.
 */
function hidePayPalBackdrop() {
    $('.paypal-loading-backdrop').removeClass('active').remove();
    $('body').removeClass('paypal-loading-active');
}

/**
 * Register express checkout components on the page that have not yet been registered.
 */
function registerExpressCheckout() {
    $(document).ready(function () {
        $('.salesforce-express-element').each(function () {
            // Element where to render the express checkout buttons component
            var element = $(this);
            if (element.hasClass('salesforce-express-element-registered')) {
                // Only register each component once
                return;
            }

            element.addClass('salesforce-express-element-registered');
            element.on('sfp:paymentcancel', onPaymentCancel);
            element.on('sfp:paymentapprove', onPaymentApprove);
            element.on('sfp:paymenterror', onPaymentError);

            // Element where to show error messages related to express checkout
            var errorElement = $('.' + element.data('errorsclass'));

            var order;
            var paymentMethodType;
            var paymentAccount;
            var sfp;

            var expressData = JSON.parse($('.salesforce-express-data').text());
            var paymentMethodSetResponse = expressData.paymentMethodSetResponse;
            var paymentZoneId = paymentMethodSetResponse.paymentZoneId;
            var useManualCapture = paymentMethodSetResponse.useManualCapture;

            // Render express stencils immediately
            expressStencils.render(element, paymentMethodSetResponse);

            // Create component configuration
            var sfpExpressConfig = {
                labels: paymentMethodSetResponse.labels,
                theme: paymentUtils.buildTheme(element[0], {
                    expressButtons: {
                        buttonLayout: paymentMethodSetResponse.expressLayout,
                        buttonShape: paymentMethodSetResponse.expressButtonShape,
                        buttonHeight: paymentMethodSetResponse.expressButtonHeight,
                        buttonColors: paymentMethodSetResponse.expressButtonColors,
                        buttonLabels: paymentMethodSetResponse.expressButtonLabels
                    }
                }),
                actions: {
                    onClick: onClick,
                    onShippingAddressChange: onShippingAddressChange,
                    onShippingMethodChange: onShippingMethodChange,
                    onPayerApprove: onPayerApprove,
                    createIntent: createIntent
                },
                options: {
                    shippingAddressRequired: paymentMethodSetResponse.shippingAddressRequired,
                    emailAddressRequired: paymentMethodSetResponse.emailAddressRequired,
                    billingAddressRequired: paymentMethodSetResponse.billingAddressRequired,
                    phoneNumberRequired: paymentMethodSetResponse.phoneNumberRequired,
                    useManualCapture: useManualCapture,
                    maximumButtonCount: paymentMethodSetResponse.expressMaximumButtonCount,
                    futureUsageOffSession: paymentMethodSetResponse.futureUsageOffSession,
                    returnUrl: element.data('return-from-async-payment')
                }
            };

            // Kick off metadata retrieval
            paymentUtils.fetchMetadata(element.data('internal-static-files-url')).then(function (metadata) {
                if (window.SFPayments) {
                    sfp = new window.SFPayments();
                    sfp.express(metadata, paymentMethodSetResponse.paymentMethodSet, sfpExpressConfig, paymentMethodSetResponse.paymentRequest, element[0], 1);

                    element.on('sfp:paymentmethodsrendered', function () {
                        requestAnimationFrame(function () {
                            element.removeClass('spinner-loading');
                            element.css('min-height', '0');
                        });
                    });
                }
            });

            /**
             * Clears any error message text which is showing.
             */
            function clearErrorMessage() {
                errorElement.empty();
            }

            /**
             * Shows the given error message, or the default error message.
             * @param {string} message - Optional error message
             */
            function showErrorMessage(message) {
                errorElement.empty().text(message || paymentMethodSetResponse.errorMessage);
                scrollAnimate(errorElement);
            }

            // Do not return a value for PayPal in order to avoid delaying the popup experience
            /* eslint-disable consistent-return */

            /**
             * Handles a click on the express checkout button.
             * @param {string} type - The payment method type
             * @returns {Promise<Object>} A promise that resolves with initial express checkout information
             */
            async function onClick(type) {
                paymentMethodType = type;
                paymentAccount = paymentUtils.findAccount(paymentMethodSetResponse.paymentMethodSet, paymentMethodType);
                clearErrorMessage();

                // Show backdrop immediately for PayPal to prevent clicks during modal loading
                if (paymentAccount.vendor === paymentUtils.VENDOR_PAYPAL) {
                    showPayPalBackdrop();
                }

                if (paymentAccount.vendor !== paymentUtils.VENDOR_PAYPAL) {
                    return {
                        amount: paymentMethodSetResponse.paymentRequest.amount.toString(),
                        shippingMethods: []
                    };
                }
            }
            /* eslint-enable consistent-return */

            /**
             * Handles a payment cancel event.
             */
            function onPaymentCancel() {
                hidePayPalBackdrop();
                showErrorMessage(paymentMethodSetResponse.cancelMessage);
            }

            /**
             * Handles the change event on the shipping address.
             * @param {Object} shippingAddress - The shipping address
             * @param {Object} callback - The callback object
             */
            async function onShippingAddressChange(shippingAddress, callback) {
                try {
                    // Update the shipping address in the current basket
                    var result = await paymentUtils.shippingAddressChange(element.data('shipping-address-change'), {
                        shippingAddress: shippingAddress
                    });
                    if (result.error) {
                        // The controller responded with an error
                        callback.updateShippingAddress({
                            errors: ['fail']
                        });
                    } else {
                        // Execute the callback with updated express information
                        callback.updateShippingAddress(result.output);
                    }
                } catch (e) {
                    // There was an error calling the controller
                    showErrorMessage();
                }
            }

            /**
             * Handles the change event on the shipping method.
             * @param {Object} shippingMethod - The shipping method
             * @param {Object} callback - The callback object
             */
            async function onShippingMethodChange(shippingMethod, callback) {
                try {
                    // Update the shipping method in the current basket
                    var result = await paymentUtils.shippingMethodChange(element.data('shipping-method-change'), {
                        shippingMethod: shippingMethod
                    });
                    if (result.error) {
                        // The controller responded with an error
                        callback.updateShippingMethod({
                            errors: ['fail']
                        });
                    } else {
                        // Execute the callback with updated express information
                        callback.updateShippingMethod(result.output);
                    }
                } catch (e) {
                    // There was an error calling the controller
                    showErrorMessage();
                }
            }

            /**
             * Called to create a payment intent or similar object during the payment lifecycle.
             * @param {Object} paymentData - information about the payment object to create
             * @returns {Object} payment object
             */
            async function createIntent(paymentData) {
                switch (paymentAccount.vendor) {
                    case paymentUtils.VENDOR_ADYEN:
                        return prepareAdyenPayment(paymentData);
                    case paymentUtils.VENDOR_PAYPAL:
                        return preparePayPalOrder();
                    case paymentUtils.VENDOR_STRIPE:
                        return prepareStripePaymentIntent();
                    default:
                        throw new Error(`Payment gateway account not found for ${paymentMethodType}`);
                }
            }

            /**
             * Prepares a PayPal order for the current basket.
             * @returns {Object} subset of PayPal order information
             */
            async function preparePayPalOrder() {
                try {
                    // Create PayPal order for the current basket
                    var result = await paymentUtils.paypal.prepareOrder(element.data('prepare-paypal-order'), {
                        zoneId: paymentZoneId,
                        shippingPreference: 'GET_FROM_FILE',
                        userAction: 'PAY_NOW',
                        fundingSource: paymentMethodType
                    });
                    if (result.error) {
                        // Hide the PayPal backdrop on error
                        hidePayPalBackdrop();
                        // The controller responded with an error
                        return showErrorMessage(result.error);
                    }

                    // Return the created PayPal order
                    return result.paypalOrder;
                } catch (e) {
                    // Hide the PayPal backdrop on error
                    hidePayPalBackdrop();
                    // There was an error calling the controller
                    return showErrorMessage();
                }
            }

            /**
             * Creates an Adyen payment intent by making an AJAX call to the server.
             * @param {Object} paymentData - The payment data needed to create the payment intent
             * @returns {Promise<Object>} A promise that resolves with the payment intent data
             */
            async function prepareAdyenPayment(paymentData) {
                try {
                    // First update the basket with complete billing and shipping data
                    var result = await paymentUtils.approveExpressPayment(element.data('approve-express-payment'), {
                        billingDetails: paymentData.billingDetails,
                        shippingDetails: paymentData.shippingDetails
                    });
                    if (result.error) {
                        // The controller responded with an error
                        return showErrorMessage(result.error);
                    }

                    // Then create a payment from the current basket, and an order
                    result = await paymentUtils.adyen.preparePayment(element.data('prepare-adyen-payment'), {
                        zoneId: paymentZoneId,
                        paymentData: paymentData,
                        paymentMethodType: paymentMethodType,
                        cardCaptureAutomatic: !useManualCapture,
                        storePaymentMethod: false,
                        setShippingData: false
                    });
                    if (result.error) {
                        // The controller responded with an error
                        return showErrorMessage(result.error.message);
                    }

                    // Track the created order
                    order = result.order;

                    // Return the created payment
                    return result.payment;
                } catch (e) {
                    // There was an error calling a controller
                    return showErrorMessage();
                }
            }

            /**
             * Creates a Stripe payment intent by making an AJAX call to the server.
             * @returns {Promise<Object>} A promise that resolves with the payment intent data
             */
            async function prepareStripePaymentIntent() {
                try {
                    // Create a payment intent from the current basket, and an order
                    var result = await paymentUtils.stripe.preparePaymentIntent(element.data('prepare-stripe-payment-intent'), {
                        zoneId: paymentZoneId,
                        paymentMethodType: paymentMethodType,
                        cardCaptureAutomatic: !useManualCapture
                    });
                    if (result.error) {
                        // The controller responded with an error
                        return showErrorMessage(result.error);
                    }

                    // Track the created order
                    order = result.order;

                    // Return the created payment intent
                    return result.paymentIntent;
                } catch (e) {
                    // There was an error calling the controller
                    return showErrorMessage();
                }
            }

            /**
             * Updates the basket with billing and shipping data from the payer approved payment.
             * @param {Object} billingDetails - Billing address details
             * @param {Object} shippingDetails - Shipping address details
             */
            async function onPayerApprove(billingDetails, shippingDetails) {
                // Show a spinner on the page
                $.spinner().start();

                // Update the basket with complete billing and shipping data
                switch (paymentAccount.vendor) {
                    case paymentUtils.VENDOR_PAYPAL:
                        // Resolve immediately for PayPal
                        return;
                    default:
                        // Update the basket with complete billing and shipping data
                        var result = await paymentUtils.approveExpressPayment(element.data('approve-express-payment'), {
                            billingDetails: billingDetails,
                            shippingDetails: shippingDetails
                        });
                        if (result.error) {
                            // The controller responded with an error
                            showErrorMessage(result.error);

                            // Hide the spinner on the page
                            $.spinner().stop();

                            throw new Error();
                        }
                }
            }

            /**
             * Handles a payment approve event.
             * @returns {Undefined} undefined
             */
            async function onPaymentApprove() {
                switch (paymentAccount.vendor) {
                    case paymentUtils.VENDOR_PAYPAL:
                        // Handle the PayPal order approval
                        return onPayPalApprove();
                    default:
                        // Otherwise navigate to the order confirmation page
                        return navigateToOrderConfirmation();
                }
            }

            /**
             * Handles a PayPal payment approve event.
             */
            async function onPayPalApprove() {
                try {
                    // Update the basket with data from the PayPal order, and create an order
                    var result = await paymentUtils.paypal.onApprove(element.data('approve-paypal-order'));
                    if (result.error) {
                        // Hide the PayPal backdrop
                        hidePayPalBackdrop();

                        // The controller responded with an error
                        showErrorMessage(result.error);

                        // Hide the spinner on the page
                        $.spinner().stop();

                        return;
                    }

                    // Track the created order
                    order = result.order;

                    // Then navigate to the order confirmation page
                    navigateToOrderConfirmation();
                } catch (e) {
                    // Hide the PayPal backdrop
                    hidePayPalBackdrop();

                    // There was an error calling the controller
                    showErrorMessage();

                    // Hide the spinner on the page
                    $.spinner().stop();
                }
            }

            /**
             * Navigates to the order confirmation page for the created order.
             */
            function navigateToOrderConfirmation() {
                paymentUtils.navigateToOrderConfirmation(element.data('order-confirm'), order.orderNo, order.orderToken);
            }

            /**
             * Handles the payment error event.
             */
            function onPaymentError() {
                // Hide the PayPal backdrop
                hidePayPalBackdrop();

                // Remove express element spinner if still showing
                element.removeClass('spinner-loading');
                element.css('min-height', '0');

                // Hide the spinner on the page, if necessary
                $.spinner().stop();

                if (order) {
                    // Fail the order
                    paymentUtils.failOrder(element.data('fail-order'), {
                        order: order
                    });
                    order = null;
                }
            }
        });
    });
}

module.exports = function () {
    $('body').on('expresscheckout:register', function () {
        registerExpressCheckout();
    });
};
